<template>
  <div>
    <h1 class="mb-0">Ученики</h1>
    <br>
    <table class="table table-borderless" v-if="students && students.length > 0">
      <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">Ученик</th>
          <th scope="col">Учитель</th>
          <th scope="col">Предмет</th>
          <th scope="col">Класс</th>
          <th scope="col">Статус оплаты</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(student, index) in students" :key="student.id">
          <td>{{ index + 1 }}</td>
          <td>{{ student.firstName }} {{ student.lastName }}</td>
          <td>{{ student.title }}</td>
          <td>{{ student.country }}</td>
          <td>{{ student.title }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'students',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      students: state => state.managers.students
    })
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('GET_STUDENTS')
  }
}
</script>